import { useForm } from "react-hook-form";
import { useDeleteUserAccount } from "@src/entities/user";
import { InputField } from "@src/shared/ui/InputField";
import { Button } from "@mui/material";
import { backButtonStyles, saveBtnStyles } from "../constants";
import { yupResolver } from "@hookform/resolvers/yup";
import { accountDeletionStep2Schema } from "./constants";
import { userАccountСhangesStore } from "@src/entities/user/model/store/userАccountСhangesStore";
import { ArrowBack } from "@mui/icons-material";

import styles from "./AccountDeletionStep2.module.scss";

interface AccountDeletionStep2Props {
  email: string;
  code: string;
}

interface Props {
  setStep: (step: number) => void;
}

export const AccountDeletionStep2 = ({ setStep }: Props) => {
  const { mutate: deleteUserAccount } = useDeleteUserAccount();
  const setInfo = userАccountСhangesStore((state) => state.setInfo);
  const deletedUserAccountInfo = userАccountСhangesStore(
    (state) => state.userАccountСhangesInfo,
  );

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<AccountDeletionStep2Props>({
    defaultValues: {
      email: deletedUserAccountInfo?.login || "",
      code: "",
    },
    resolver: yupResolver(accountDeletionStep2Schema) as any,
  });

  const onSubmit = (data: AccountDeletionStep2Props) => {
    const params = { code: data.code, ...deletedUserAccountInfo };
    deleteUserAccount(params, {
      onSuccess: () => {
        setInfo(params);
        setStep(3);
      },
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
      <InputField
        control={control}
        name="email"
        label="Почта"
        classNameForWrapper={styles.inputFieldWrapper}
        className={styles.inputField}
        disabled
      />
      <InputField
        control={control}
        name="code"
        label="Код"
        classNameForWrapper={styles.inputFieldWrapper}
        className={styles.inputField}
      />
      <Button
        type="submit"
        variant="contained"
        disabled={!isValid}
        sx={saveBtnStyles}
      >
        Сохранить
      </Button>
      <Button
        variant="text"
        onClick={() => setStep(1)}
        sx={backButtonStyles}
        type="button"
        startIcon={<ArrowBack />}
      >
        Вернуться
      </Button>
    </form>
  );
};
